var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "rb-header-base-side-panel",
    _vm._b(
      {
        staticClass: "rb-header-navigation-menu-panel",
        scopedSlots: _vm._u(
          [
            {
              key: "content",
              fn: function () {
                return [
                  _c("div", { staticClass: "menu__sections" }, [
                    _c(
                      "div",
                      { staticClass: "section__buttons" },
                      [_vm._t("content")],
                      2
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "section__omnichannel" },
                      [_vm._t("omnichannel")],
                      2
                    ),
                  ]),
                ]
              },
              proxy: true,
            },
          ],
          null,
          true
        ),
      },
      "rb-header-base-side-panel",
      _vm.$props,
      false
    )
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }